/*
 * Dropdown selection component
 */

import React from 'react';

import {
  Mode,
  castDataType,
  DataType
} from '../common.jsx';

import Helpers from './helpers.jsx';
import Setting from './setting.jsx';

import Selection from './selection.jsx'
export default class DropdownSelection extends Selection {

        static get TYPE() {
            return 'dropdown_selection';
        }

        static icon(){
            return <i className="fa fa-caret-down"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'field_default_label',
                description: 'field_default_description',
                help: null,
                blankOptionLabel: 'select_blank_option_default',
                changeConfirmText: null
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                includeBlank: false,
                blankOptionLabel: 'blankOptionLabel',
                sourcesOfPrefill: ''
            });
        }

        constructor(props){
            super(props);
            this.selectClicked = this.selectClicked.bind(this);
            this.handleChange = this.handleChange.bind(this);
            this.storedLabelName = this.storedLabelName.bind(this);
            this.getStoredLabel = this.getStoredLabel.bind(this);
        }


        renderView() {
            return (
                <div>
                    {this.getLockedInformationTooltip(this.modeFillOrView() && this.isReadOnlyPrefilledAnswer(), <>
                        <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                            <span className="field-label">{this.getText('label')}</span>
                            {this.props.content.required ? <span className='required-field'> *</span> : null}
                            {this.helpIcon()}
                            {this.renderPrefillIcon()}
                            {this.renderOptions()}
                        </label>
                        {this.descriptionText()}
                        {!this.modeFillOrView() && this.isReadOnlyAnswer() ? this.lockedInformationDefault() : ''}
                    </>)}
                </div>
            );
        }

        renderSettings() {
            return (
                <div>
                    {this.renderDataGridDetails()}
                    {this.isDatagridContextAvailable() && this.renderDatagridContextSettings()}
                    {super.renderSettings()}
                    <Setting.Checkbox name="includeBlank" label={I18n.t('field_include_blank', {scope: 'fe'})} value={this.props.content.includeBlank} onChange={this.updateSettings} />
                    <Setting.TextField name="blankOptionLabel" label={I18n.t('select_blank_option_label', {scope: 'fe'})} value={this.getText('blankOptionLabel')} onChange={this.updateSettings} />

                    {this.renderSourcesOfPrefillSettings()}
                </div>
            )
        }

        renderOptions() {
            let configuredOptions = this.getOptions()
            
            let options = configuredOptions.map((o, i) => {
                return (
                    <option key={(i + 1) + '-' + o.value} value={o.value}>{this.renderOption(o)}</option>
                );
            });

            if (this.props.content.includeBlank) {
                options = [<option key={0} value="">{this.getText('blankOptionLabel')}</option>].concat(options);
            }

            let hiddenValue = null;
            let currentAnswer = this.getAnswer();

            if (this.isReadOnlyAnswer()) {
                hiddenValue = <input type="hidden" name={this.fullFieldName()} defaultValue={currentAnswer} />
            }

            return (
                <div style={{ position: "relative" }}>
                    {hiddenValue}
                    <select
                        key={options.length} // Forces update when options change
                        name={this.fullFieldName()} 
                        value={currentAnswer}
                        autoComplete={this.getAutoComplete()}
                        readOnly={this.props.mode != Mode.FILL}
                        disabled={this.props.mode == Mode.FILL && this.isReadOnlyAnswer() || this.props.disabled}
                        onMouseDown={this.selectClicked}
                        onChange={this.handleChange}
                        className={`form-control ${this.isReadOnlyAnswer() ? 'locked' : ''} ${this.getInputClassNames()}`}>
                        {options}
                    </select>

                    {/* Store the label of a dynamic option on change to avoid having to fetch it. */}
                    {this.useDatagridContextual() && this.props.mode == Mode.FILL && <input 
                      type="hidden" 
                      name={this.storedLabelName()} 
                      defaultValue={configuredOptions.find(o => o.value == currentAnswer)?.label}
                    />}
                </div>
            );
        }

        handleChange(e) {
          this.updateAnswer(e.target.value);
        }

        // Store the label of a dynamic option on change to avoid having to fetch it.
        // Need to do it in this horrible way due to uncontrolled inputs.
        storedLabelName() {
          return this.fullFieldName(false, '_option_label')
        }

        // Get the stored label in view mode
        getStoredLabel() { 
          let fieldNamePath = Helpers.fieldNamePath(this.storedLabelName(), this.props.fieldScope);          
          return Helpers.getObjectValue(this.props.answers || {}, fieldNamePath)
        }

        selectClicked(e) {
            if (this.props.mode != Mode.FILL) {
                e.preventDefault();
                return false;
            }
        }

        beforeUpdateSettings(content) {
            
            super.beforeUpdateSettings(content);
            content.includeBlank = castDataType(content.includeBlank, DataType.BOOLEAN);

            // Blank option should be included in case the field is required
            if (content.required) {
                content.includeBlank = true;
            }
        }

        getAnswer() {
            let answer = super.getAnswer();

            // Effectively the selected answer is the first visible option unless a blank option is included
            if (!this.props.content.includeBlank && !answer) {
                answer = castDataType((this.getOptions()[0] || {}).value || '', this.props.content.dataType);
            }
            return answer;
        }
}
